import { SharedService } from '../common/extends_fw/controller/PjBaseController';
import { Net } from '../common/extends_fw/Net';

import { CommonConst } from '../common/CommonConst';
import { DashboardController } from './controller/DashboardController';
import { DashboardService } from './service/DashboardService';
import { DashboardApi } from './api/DashboardApi';
import { HeaderController } from './controller/HeaderController';
import { HeaderService } from './service/HeaderService';
import { HeaderApi } from './api/HeaderApi';
import { LoginController, LoginEditController } from './controller/LoginController';
import { LoginService } from './service/LoginService';
import { LoginApi } from './api/LoginApi';
import { LoginPasswordController } from './controller/LoginPasswordController';
import { LoginPasswordService } from './service/LoginPasswordService';
import { LoginPasswordApi } from './api/LoginPasswordApi';
import { UserController, UserEditController } from './controller/UserController';
import { UserService } from './service/UserService';
import { UserApi } from './api/UserApi';
import { ViewingHistoryController } from './controller/ViewingHistoryController';
import { ViewingHistoryService } from './service/ViewingHistoryService';
import { ViewingHistoryApi } from './api/ViewingHistoryApi';
import { CompanyController, CompanyEditController } from './controller/CompanyController';
import { CompanyService } from './service/CompanyService';
import { CompanyApi } from './api/CompanyApi';
import { GroupController, GroupEditController } from './controller/GroupController';
import { GroupService } from './service/GroupService';
import { GroupApi } from './api/GroupApi';
import { VideoController, VideoEditController } from './controller/VideoController';
import { VideoService } from './service/VideoService';
import { VideoApi } from './api/VideoApi';
import { CategoryController, CategoryEditController } from './controller/CategoryController';
import { CategoryService } from './service/CategoryService';
import { CategoryApi } from './api/CategoryApi';
import { RecommendController, RecommendEditController } from './controller/RecommendController';
import { RecommendService } from './service/RecommendService';
import { RecommendApi } from './api/RecommendApi';
import { SeriesController, SeriesEditController } from './controller/SeriesController';
import { SeriesService } from './service/SeriesService';
import { SeriesApi } from './api/SeriesApi';
import { PackController, PackEditController } from './controller/PackController';
import { PackService } from './service/PackService';
import { PackApi } from './api/PackApi';
import { NoticeController, NoticeEditController } from './controller/NoticeController';
import { NoticeService } from './service/NoticeService';
import { NoticeApi } from './api/NoticeApi';
import { UserCapController } from './controller/UserCapController';
import { UserCapService } from './service/UserCapService';
import { UserCapApi } from './api/UserCapApi';
import { PasswordController } from './controller/PasswordController';
import { PasswordService } from './service/PasswordService';
import { PasswordApi } from './api/PasswordApi';
import { BlankController } from './controller/BlankController';

/**
 * AngularJSのモジュールに大分類で作成するべきコンポーネントを登録します
 * @param {ng.IModule} angularModule AngularJSのモジュール
 */
export function init(angularModule: ng.IModule): void {

    angularModule.factory('sharedService', (): SharedService => {
            return new SharedService();
    });

    angularModule.controller('dashboardController', DashboardController);
    angularModule.service('dashboardService', DashboardService);
    angularModule.factory('dashboardApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): DashboardApi => {
            return new DashboardApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('headerMAController', HeaderController);
    angularModule.service('headerService', HeaderService);

    angularModule.factory('headerApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): HeaderApi => {
            return new HeaderApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('loginController', LoginController);
    angularModule.controller('loginEditController', LoginEditController);
    angularModule.service('loginService', LoginService);

    angularModule.factory('loginApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): LoginApi => {
            return new LoginApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('loginPasswordController', LoginPasswordController);

    angularModule.service('loginPasswordService', LoginPasswordService);

    angularModule.factory('loginPasswordApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): LoginPasswordApi => {
            return new LoginPasswordApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('userController', UserController);
    angularModule.controller('userEditController', UserEditController);

    angularModule.service('userService', UserService);

    angularModule.factory('userApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): UserApi => {
            return new UserApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('viewingHistoryController', ViewingHistoryController);

    angularModule.service('viewingHistoryService', ViewingHistoryService);

    angularModule.factory('viewingHistoryApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): ViewingHistoryApi => {
            return new ViewingHistoryApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('companyController', CompanyController);
    angularModule.controller('companyEditController', CompanyEditController);

    angularModule.service('companyService', CompanyService);

    angularModule.factory('companyApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): CompanyApi => {
            return new CompanyApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('groupController', GroupController);
    angularModule.controller('groupEditController', GroupEditController);

    angularModule.service('groupService', GroupService);

    angularModule.factory('groupApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): GroupApi => {
            return new GroupApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('videoController', VideoController);
    angularModule.controller('videoEditController', VideoEditController);

    angularModule.service('videoService', VideoService);

    angularModule.factory('videoApi', ($http: ng.IHttpService, $q: ng.IQService, Upload: any, $httpParamSerializer?: ng.IHttpParamSerializer): VideoApi => {
            return new VideoApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH), Upload);
    });

    angularModule.controller('categoryController', CategoryController);
    angularModule.controller('categoryEditController', CategoryEditController);

    angularModule.service('categoryService', CategoryService);

    angularModule.factory('categoryApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): CategoryApi => {
            return new CategoryApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('recommendController', RecommendController);
    angularModule.controller('recommendEditController', RecommendEditController);

    angularModule.service('recommendService', RecommendService);

    angularModule.factory('recommendApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): RecommendApi => {
            return new RecommendApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('seriesController', SeriesController);
    angularModule.controller('seriesEditController', SeriesEditController);

    angularModule.service('seriesService', SeriesService);

    angularModule.factory('seriesApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): SeriesApi => {
            return new SeriesApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('packController', PackController);
    angularModule.controller('packEditController', PackEditController);

    angularModule.service('packService', PackService);

    angularModule.factory('packApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): PackApi => {
            return new PackApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('noticeController', NoticeController);
    angularModule.controller('noticeEditController', NoticeEditController);

    angularModule.service('noticeService', NoticeService);

    angularModule.factory('noticeApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): NoticeApi => {
            return new NoticeApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('userCapController', UserCapController);

    angularModule.service('userCapService', UserCapService);

    angularModule.factory('userCapApi', ($http: ng.IHttpService, $q: ng.IQService, Upload: any, $httpParamSerializer?: ng.IHttpParamSerializer): UserCapApi => {
            return new UserCapApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH), Upload);
    });

    angularModule.controller('passwordController', PasswordController);

    angularModule.service('passwordService', PasswordService);

    angularModule.factory('passwordApi', ($http: ng.IHttpService, $q: ng.IQService, $httpParamSerializer?: ng.IHttpParamSerializer): PasswordApi => {
            return new PasswordApi($http, $q, $httpParamSerializer, CommonConst.SERVER_PATH, new Net($http, CommonConst.SERVER_PATH));
    });

    angularModule.controller('blankController', BlankController);

    angularModule.config(function($sceDelegateProvider: any): any {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            'http://d3se3bdfhhn1od.cloudfront.net/**',
            'https://d3se3bdfhhn1od.cloudfront.net/**',
            'http://dkn07u612dhp2.cloudfront.net/**',
            'https://dkn07u612dhp2.cloudfront.net/**',
            'http://d8sfhlnam129q.cloudfront.net/**',
            'https://d8sfhlnam129q.cloudfront.net/**'
        ]);
    });

    angularModule.config(function($provide: any): any {
        let directiveTypes: any = ['Submit', 'Click'];
        angular.forEach(directiveTypes, function(type: any, key: any): any {
            $provide.decorator(('ng' + type + 'Directive'), function($delegate: any, $parse: any): any {
                $delegate[0].compile = function($element: any, attr: any): any {
                    let fn: any = $parse(attr['ng' + type], null, true);
                    let timer: any;
                    return function(scope: any, element: any): any {
                        element.on(type.toLowerCase(), function(event: any): any {
                            let _fn: any = function(): any {
                                scope.$apply(function(): any {
                                    fn(scope, { '$event' : event });
                                });
                            };
                            if (timer) {
                                clearTimeout(timer);
                            }
                            timer = setTimeout(_fn, 100); // 処理中のボタン操作不可時間
                        });
                        let destroyer: any = scope.$on('$destroy', function(): any {
                            element.off();
                            destroyer();
                        });
                    };
                };
                return $delegate;
            });
        });
    });
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/init.ts
 **/